module.exports = __webpack_public_path__ + "dist/assets/5aa0a1c49a28bb46d0eab09c92b7494e.woff";